import React from 'react';
import axios from 'axios';
import {USER_LIST} from "../../api/Api";

function buildFilterParams(filters){

}

export default function
    (filters,itemsPerPage,reloadKey){

    const [isLoading,setIsLoading] = React.useState(false);
    const [users,setUsers] = React.useState([]);
    const [loadingError,setLoadingError] = React.useState(undefined);

    React.useEffect(
        () => {

            setIsLoading(true)

            axios
                .get(
                    USER_LIST
                ).then(
                ({data}) => {
                    setUsers(data.data);
                }
            )
                .catch(
                    error => {
                        setLoadingError(error)
                    }
                )
                .finally(
                ()=>{
                    setIsLoading(false);
                }
            )

        }, [reloadKey]
    );

    return [isLoading,loadingError,users]
}